import { useEffect, useState } from "react";

/**
 * Thin horizontal gold bar at the very top of the viewport that grows in
 * width as the user scrolls down the page. Purely decorative — helps
 * readers gauge progress through long content (Problem, Solution, Platform).
 */
export default function ScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const update = () => {
      const el = document.documentElement;
      const scrolled = el.scrollTop;
      const height = el.scrollHeight - el.clientHeight;
      setProgress(height > 0 ? (scrolled / height) * 100 : 0);
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <div
      className="fixed top-0 left-0 right-0 h-[3px] z-[60] pointer-events-none"
      data-testid="scroll-progress"
      aria-hidden
    >
      <div
        className="h-full bg-gradient-to-r from-gold-deep via-gold to-gold-light transition-[width] duration-100 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
